import React from "react";
import SEO from "../../../hooks/SEO";
import Service from "../Service";
import { serviceDetails, siteMeta } from "../../../data/mockData";

const Trade = () => (
  <>
    <SEO
      title={`${serviceDetails["international-trade"].title} | Refwa`}
      description={serviceDetails["international-trade"].intro}
      name={siteMeta.name}
      type="website"
    />
    <Service service={serviceDetails["international-trade"]} />
  </>
);

export default Trade;
